import {Table, DataTable} from '@primer/react/experimental'
import type {EditablePreview} from '../types'
import {Preview} from './preview'
import {Checkbox} from '@primer/react'
import {useUpdatePreviews} from '../contexts/UpdatePreviewsContext'
import {useIsLoading} from '../contexts/IsLoadingContext'

export type PreviewsTableProps = {
  previews: EditablePreview[]
}

export function PreviewsTable({previews}: PreviewsTableProps) {
  const isLoading = useIsLoading()
  const {togglePreview} = useUpdatePreviews()

  if (isLoading) {
    return (
      <Table.Container>
        <h2 className="sr-only" id="previews-table">
          Ruleset previews
        </h2>
        <Table.Skeleton
          cellPadding="spacious"
          aria-labelledby="repositories-loading"
          rows={3}
          columns={[
            {
              header: 'Rule',
              id: 'targetedBranches',
            },
            {
              header: 'Ruleset name',
              id: 'rulesets',
            },
          ]}
        />
      </Table.Container>
    )
  }

  return (
    <>
      <h2 className="sr-only" id="previews-table">
        Ruleset previews
      </h2>
      <Table.Container>
        <DataTable
          aria-labelledby="previews-table"
          data={previews}
          columns={[
            {
              header: 'Rule',
              field: 'targetedBranches',
              renderCell(preview) {
                return (
                  <span className="d-flex flex-row flex-items-center gap-1">
                    <Checkbox
                      disabled={preview.isDisabled}
                      checked={preview.isEnabled}
                      onChange={() => togglePreview({id: preview.id})}
                    />{' '}
                    <code className={preview.isDisabled ? 'fgColor-muted' : ''}>{preview.targetedBranches}</code>
                  </span>
                )
              },
            },
            {
              header: 'Ruleset name',
              field: 'rulesets',
              renderCell(preview) {
                return <Preview preview={preview} />
              },
            },
          ]}
        />
      </Table.Container>
    </>
  )
}
